import NewWord from './new-word';

export default NewWord;
